module.exports = __webpack_public_path__ + "images/waiting_75e9195.svg";